import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "modal__header" };
const _hoisted_2 = { class: "modal__title" };
const _hoisted_3 = { class: "modal__content" };
import Modal from "./Modal.vue";
import AppForm from "./form/AppForm.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'ModalForm',
    props: {
        form: {},
        data: {},
        validation: {},
        title: {},
        variant: {},
        submitLabel: {},
        submitIcon: {},
        cancelLabel: {},
        modalSize: {},
        loading: { type: Boolean }
    },
    emits: [
        'submit',
        'cancel',
        'change'
    ],
    setup(__props, { emit: __emit }) {
        const emit = __emit;
        function onSubmit() {
            emit('submit');
        }
        function onCancel() {
            emit('cancel');
        }
        function onChange(data) {
            emit('change', data);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(Modal, {
                classes: ['modal-form', 'modal--' + (__props.modalSize ?? '')],
                onClose: onCancel
            }, {
                body: _withCtx(() => [
                    _createElementVNode("header", _hoisted_1, [
                        _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$te(__props.title) ? _ctx.$t(__props.title) : __props.title), 1)
                    ]),
                    _cache[1] || (_cache[1] = _createTextVNode()),
                    _createElementVNode("section", _hoisted_3, [
                        _createVNode(AppForm, {
                            class: "modal-form__form",
                            form: __props.form,
                            data: __props.data,
                            validation: __props.validation,
                            variant: __props.variant,
                            "submit-label": __props.submitLabel,
                            "cancel-label": __props.cancelLabel,
                            "submit-icon": __props.submitIcon,
                            loading: __props.loading,
                            onSubmit: onSubmit,
                            onCancel: onCancel,
                            onChange: onChange
                        }, {
                            content: _withCtx(() => [
                                _renderSlot(_ctx.$slots, "content")
                            ]),
                            buttons: _withCtx(() => [
                                _renderSlot(_ctx.$slots, "buttons")
                            ]),
                            _: 3
                        }, 8, ["form", "data", "validation", "variant", "submit-label", "cancel-label", "submit-icon", "loading"])
                    ]),
                    _cache[2] || (_cache[2] = _createTextVNode()),
                    _renderSlot(_ctx.$slots, "footer")
                ]),
                _: 3
            }, 8, ["classes"]));
        };
    }
});
